export const ORDER_URL = 'https://www.epipay.com/take/en/WebOrder?STORE_CODE=MTAwMA==&table_num=MTAwMA==';
export const INSTAGRAM_URL = 'https://www.instagram.com/takesushi_mi/';
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=100067170430552';
export const hours = [['Monday', 'Closed'], ['Tuesday – Friday', '11:00 A.M. – 8:30 P.M.'], ['Saturday', '12:00 P.M. – 8:30 P.M.'], ['Sunday', '4:00 P.M. – 8:30 P.M.']];
